import React, { useState} from "react";

import {BackHandler, View, Text, Alert, Linking}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import {estilos} from '../util/estilos'

import * as util from '../util/util'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import { useFocusEffect } from '@react-navigation/native';

import Botao from '../componentes/Botao'

import {semDados} from '../componentes/SemDados'

import {buscar, avaliar as wsAvaliar, gerarToken} from '../ws/ws_denuncia'

import {carregamento} from '../componentes/Carregamento'

import {MSG_ERRO_PADRAO, TELA_PRINCIPAL,
	DNC_TIPO_RELACAO_USUARIO, DNC_TIPO_RELACAO_ITEM, DNC_TIPO_SERVICO_PEDIDO, 
	DNC_TIPO_SERVICO_PROPOSTA, DNC_TIPO_SERVICO_MENSAGEM} from '../util/constantes'

import cores from '../util/cores'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'

import Combo from '../componentes/Combo'

import * as data from '../util/data'

import {WS_URL_FICHA_DENUNCIA} from '../util/params'




export default function TelaDenuncias(){
   
	const navegacao = new useNavigation();
	
	const [sincronizando, setSincronizando] = useState(true)  

	const listaTipos = [{"id": DNC_TIPO_RELACAO_USUARIO, "nome": "Usuário"},
						{"id": DNC_TIPO_RELACAO_ITEM, "nome": "Anúncio"},
						{"id": DNC_TIPO_SERVICO_PEDIDO, "nome": "Pedido"},
						{"id": DNC_TIPO_SERVICO_PROPOSTA, "nome": "Proposta"},
						{"id": DNC_TIPO_SERVICO_MENSAGEM, "nome": "Mensagem"}];
	

	const listaSituacoes = [{"id": 0, "nome": "Pendente"},{"id": 1, "nome": "Concluído"}]

	const listaConclusao = [{"id": 0, "nome": "Improcedente"},{"id": 1, "nome": "Procedente"}]

	const [tipo, setTipo] = useState(null)

	const [situacao, setSituacao] = useState(listaSituacoes[0].id)

	const [conclusao, setConclusao] = useState(null)

	const [lista, setLista] = useState([])  
	

	
	const voltar = () => {
		navegacao.replace(util.processaVoltar())
		return true
	};


	useFocusEffect(React.useCallback(() => {

		util.print("TelaDenuncias");
		
		BackHandler.addEventListener('hardwareBackPress', voltar);

		buscarDados();

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	
	}, []));
	
	
	const buscarDados= async ()=>{

		setSincronizando(true);
		
		let aux = await buscar(tipo, situacao, conclusao);
		
		setLista(util.temConteudo(aux)?aux:[])
			
		setSincronizando(false)
	}


	async function avaliar(id_denuncia, resultado){
		
		setSincronizando(true);

		if(await wsAvaliar(id_denuncia, resultado)==null){
                
			Alert.alert("Atenção", MSG_ERRO_PADRAO);
            return; 
        }

		buscarDados();
    }


	async function abrirFichaDenuncia(id_denuncia){
		
		let aux = await gerarToken(id_denuncia);

		if(aux==null || aux.token == null){
                
			Alert.alert("Atenção", MSG_ERRO_PADRAO);
            return; 
        }
		
  		Linking.openURL(WS_URL_FICHA_DENUNCIA+aux.token).catch((err) =>Alert.alert("Atenção", MSG_ERRO_PADRAO));
	}


	function formularioPesquisa(){
		
		return (
			<View style={{flex:1}}>  
				<Bloco podeRecolher={true}>   
					<View style={{marginTop:10}}/>	
					
					<Combo 
						mostrarVazio = {false}
						rotulo="Situação:" 
						selecionado={situacao==null || situacao == listaSituacoes[0].id?listaSituacoes[0]:listaSituacoes[1]} 
						dados={listaSituacoes} 
						aoMudar={(valor)=>setSituacao(valor.id)}/>

					<Combo 
						rotulo="Denúncia de:" 
						selecionado={tipo} 
						dados={listaTipos} 
						aoMudar={(valor)=>setTipo(valor.id)}/>

				
					<Combo 
						rotulo="Conclusão:" 
						selecionado={conclusao} 
						dados={listaConclusao} 
						aoMudar={(valor)=>setConclusao(valor.id)}/>


					<View style={{marginTop:10}}/>
					
					<View style={{alignItems:'center'}}>
						<Botao 
							acao={()=>buscarDados()}
							texto="Carregar Denúncias"/>    
					</View>
				</Bloco>
								
				{(util.temConteudo(lista))?
					(lista.map((item, index) => itemLista(item, index))):
					(<Bloco todaArea={true}> 
						<View style={{marginTop:10}}/>
							{semDados("info", "Nenhuma denúncia enviada.", 60)}
						<View style={{marginTop:10}}/>	
					</Bloco>)
				}					
			</View>	
		)
	}


	function itemLista(item, index){
		
		return (
			<Bloco key={index}> 
				<View style={{marginTop:10}}/>
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}>
						<Text style={estilos.rotulo_menor}>Enviando em: {data.converteDataEuaParaBr(item.data_entrada)}</Text>
					</View>
					<View style={{alignItems:'flex-end'}}> 
						<Text style={estilos.rotulo_menor}>Avaliado em: {data.converteDataEuaParaBr(item.data_conclusao)}</Text>
					</View>
				</View>
				<View style={{marginTop:20}}/>  
				<Text style={estilos.rotulo_padrao}>{item.cpf_cnpj_denunciante} {item.nome_denunciante}</Text>
				<View style={{marginTop:10}}/>  
				<Text style={estilos.rotulo_titulo}>{item.descricao_categoria}</Text>
				<View style={{marginTop:10}}/>
				{item.situacao>0 && 
					<View> 
						<Text style={estilos.rotulo_titulo}>Conclusão: {item.conclusao ==0?"IMPROCEDENTE": "PROCEDENTE"}</Text>
					</View>
				}
				<View style={{marginTop:20}}/>

				<View style={{alignItems:'center'}}>
					<Botao 
						acao={()=>abrirFichaDenuncia(item.id)}
						somente_texto={true}
						texto="Ficha de Denúncia"/>    
				</View>

				{item.situacao<=0 && 
					<View>
						<View style={{marginTop:20}}/>
						<View style={estilos.separador}/>
						<View style={{marginTop:20}}/>
						
						<View style={estilos.grade}>
							<View style={[estilos.coluna, {alignItems:'flex-start'}]}>
								<Botao 
									acao={()=>avaliar(item.id, listaConclusao[1].id)}
									texto="Procedente"/>    
							</View>
							<View style={[estilos.coluna, {alignItems:'flex-end'}]}>
								<Botao 
									acao={()=>avaliar(item.id, listaConclusao[0].id)}
									texto="Improcedente"
									cor={cores.vermelho}/>    
							</View>
						</View>
					</View>
				}
				<View style={{marginTop:10}}/>
			</Bloco>)
	}


	function formularioAvaliando(){
		
		return (
			<View></View>
		)
	}


	return (
		<ViewDegradeVertical titulo="Denúncias" voltar={()=>voltar()}>
			{(sincronizando) ?
				(carregamento(sincronizando)):
				(<Scroll> 	
					{formularioPesquisa()}	
				</Scroll>)
			}
		</ViewDegradeVertical>	
	);
}